import * as angular from 'angular';
import { MeurhAdmissoesestagiarioDocumentacaoFormController } from './documentacao.form.controller';

export class MeurhAdmissoesestagiarioDocumentacaoFormComponent implements angular.IComponentOptions {
	static selector = 'meurhAdmissoesestagiarioDocumentacaoFormComponent';
	static controller = MeurhAdmissoesestagiarioDocumentacaoFormController;
	static template = require('!!html-loader!./documentacao.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
	};
}
